import BigNumber from "bignumber.js";

export const thousandSeparator = (value, fixed) => {
  const temp = new BigNumber(value || 0);

  if (temp.isNaN()) {
    return '--';
  }

  let digit = 0;

  if (value) {
    digit = String(value).split('.')[1]?.length || 0;
  }
  // 大于100取小数点后两位
  if (temp.gt(100)) {
    digit = 2;
  }

  return temp.toFormat(typeof fixed != 'undefined' ? fixed : digit);
};

// 站点语言（与 next.config i18n.locales 对齐）
export const localesConfig = ["default", "en", "zh-CN", "pt", "ar", "vi"];
